import { useEffect, useState } from 'react';
import { ReactComponent as CloseIcon } from '../../../assets/icons/trvto_close.svg';
import StayManualBooking from '../../../pages/supBooking/bookingTypes/StayManualBooking';
import { orgStayListingsFun, orgStayManualFun } from '../../../api/orgCampAPI';
import errorHandle from '../../../utils/errorHandle';
import '../../addBooking/addBooking.css';

/*
 * Organizer > Camp header "Add Booking": pick one of your stays, then the same
 * phone / walk-in booking form support uses (price, rules and free rooms are
 * checked on the server; rooms are taken when it's saved).
 */
export default function OrgCampAddBooking({ setAddBo }) {
    const [listings, setListings] = useState([]);
    const [listingId, setListingId] = useState('');

    useEffect(() => {
        orgStayListingsFun()
            .then((res) => {
                const list = (res?.data || []).filter((l) => l.status !== 'inactive');
                setListings(list);
                if (list.length === 1) setListingId(String(list[0]._id));
            })
            .catch(errorHandle);
    }, []);

    // the form asks for the stay's rooms; we already have them from the listings call
    const api = {
        units: async (id) => listings.find((l) => String(l._id) === String(id))?.units || [],
        save: (data) => orgStayManualFun(data)
    };

    return (
        <div className='orgAddBoBack'>
            <div className='orgAddBoDiv'>
                <h3 className='orgAddBoH1'>Add New Booking</h3>
                <button onClick={() => setAddBo(false)} className='orgAddBoCancel' aria-label='Close'>
                    <CloseIcon className='orgAddBoCloseIcon' />
                </button>
                <div className='orgAddBoSubDiv'>
                    <select
                        className='select'
                        aria-label='Stay'
                        value={listingId}
                        onChange={(e) => setListingId(e.target.value)}
                    >
                        <option value=''>Select Stay</option>
                        {listings.map((l) => (
                            <option key={l._id} value={l._id}>
                                {l.title}
                            </option>
                        ))}
                    </select>
                    {listingId && listings.length > 0 && (
                        <StayManualBooking
                            listingId={listingId}
                            api={api}
                            collectedLabel='Amount you collected (₹)'
                            onClose={() => setAddBo(false)}
                            onSaved={() => setAddBo(false)}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}
